
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useAuth } from "../lib/auth";
import SigningIn from "./authenticating";
import SignIn from "./signin";

import { PageHeader } from "../components/PageHeader";

export default function Home() {
  const { auth } = useAuth();

  return (
    <div>
      <PageHeader
        title='TGL Wellbeing Buddy'
        description='Increase your productivity with the TGL Wellbeing Buddy app by The Goof Life Tools'
        follow={true}
      />
      <main>{auth ? <SigningIn /> : <SignIn />}</main>
      <footer></footer>
    </div>
  );
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  